import React from "react";
import IdNameModel from "../../../models/common/IdNameModel";
import VendorSubUserRequirementsGridComponent from "./VendorSubUserRequirementsGridComponent";
import { Controller, useForm } from "react-hook-form";
import JobPostingVendorRequestModel from "../../../models/company/jobPosting/request/JobPostingVendorRequestModel";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import VendorRequirementGridModel from "../../../models/company/vendorUser/response/VendorRequirementGridModel";
import { FORM_SELECT_RULE } from "../../../utils/validation-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { Autocomplete, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@mui/material";

interface JobPostingVendorProps {
    requirementVendors: VendorRequirementGridModel[];
    vendorForRequiremrntList: IdNameModel[];
    vendorSubUserId: string;
    onVendorSave: (objVendor: JobPostingVendorRequestModel) => void;
    onCloseVendor: () => void;
};

const VendorSubUserRequirementsComponent = (props: JobPostingVendorProps) => {
    const {
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<JobPostingVendorRequestModel>({
        mode: "onChange"
    });

    const onSubmit = (formData: JobPostingVendorRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        formData.vendorId = props.vendorSubUserId;
        formData.userId = GuidEnum.Empty;
        props.onVendorSave(formData);
    }

    return (
        <>
            <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <div className="col-md-6">
                        <Controller name="requirementId" control={control} defaultValue={GuidEnum.Empty} rules={FORM_SELECT_RULE}
                            render={({ field }) => (
                                <Autocomplete {...field} value={props.vendorForRequiremrntList.find(x => x.guId === field.value) || null}
                                    onChange={(_, newValue) => field.onChange(newValue ? newValue.guId : GuidEnum.Empty)} options={props.vendorForRequiremrntList} getOptionLabel={(option) => option.name || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Requirement" size="small" required margin="normal" fullWidth error={!!errors.requirementId} helperText={errors.requirementId?.message} />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.guId === value.guId}
                                />
                            )}
                        />
                    </div>
                    <div className="col-md-6">
                        <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                            Save
                        </Button>
                        <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseVendor}>
                            Close
                        </Button>
                    </div>
                </div>
            </form>
            <VendorSubUserRequirementsGridComponent
                requirementsList={props.requirementVendors} />
        </>
    );
};
export default VendorSubUserRequirementsComponent;